<template>
    <div class="footter">
        <div class="footer-top">
            <div>
                <div class="title">
                    <img src="../assets/logo-footer.webp" alt="logo" class="logo" />
                    บริษัท ดีพีที พิโก กรุ๊ป จำกัด
                </div>
                <div class="desc">
                    เสริมศักยภาพสตาร์ทอัพและธุรกิจดิจิทัล ด้วยเทคโนโลยีล้ำสมัยที่รองรับการขยายตัวอย่างไร้ขีดจำกัด
                    พร้อมส่งมอบประสบการณ์ผู้ใช้ที่เหนือระดับ
                </div>
            </div>
            <div>
                <div class="title">
                    ติดต่อเรา
                </div>
                <div class="text">
                    หากคุณต้องการความช่วยเหลือใด ๆ โปรดส่งอีเมลถึงเรา
                </div>
            </div>
        </div>
        <div class="footer-content">
            <div class="item">
                <img src="../assets/footer-icon1.webp" alt="" class="icon">
                <div class="text">97/138 ถนนสุวินทวงศ์ แขวงมีนบุรี เขตมีนบุรี กรุงเทพมหานคร 10510</div>
            </div>
            <div class="item">
                <img src="../assets/footer-icon2.webp" alt="" class="icon">
                <div class="text">08 9962 6362</div>
            </div>
            <div class="item">
                <img src="../assets/footer-icon3.webp" alt="" class="icon">
                <div class="text">1204/2569</div>
            </div>
            <div class="item">
                <img src="../assets/footer-icon4.webp" alt="" class="icon">
                <div class="text">วันอาทิตย์  08:00-20:00 น</div>
            </div>
        </div>
        <div class="c">
            © 2026 บริษัท ดีพีที พิโก กรุ๊ป จำกัด สงวนลิขสิทธิ์
        </div>
    </div>
</template>
<script setup>
</script>
<style lang="less" scoped>
.footter {
    width: 100%;
    height: 259px;
    background: #001642;
    padding: 31px 220px 0;
    box-sizing: border-box;

    .footer-top {
        display: flex;
        justify-content: space-between;
        margin-bottom: 45px;

        .title {
            display: flex;
            align-items: center;
            font-weight: bold;
            font-size: 15px;
            color: #D3D3D3;
            line-height: 15px;

            .logo {
                width: 44px;
                height: 44px;
                object-fit: cover;
                margin-right: 7px;
            }
        }

        .desc {
            width: 347px;
            height: 36px;
            font-family: DIN, DIN;
            font-weight: 500;
            font-size: 12px;
            color: #D3D3D3;
            line-height: 18px;
            margin-left: 51px;
        }

        .text {
            margin-top: 22px;
            font-weight: 500;
            font-size: 12px;
            color: #D3D3D3;
            line-height: 18px;
        }
    }

    .footer-content {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 31px;

        .item {
            display: flex;
            align-items: center;

            .icon {
                width: 27px;
                height: 27px;
                object-fit: contain;
                margin-right: 8px;
            }

            .text {
                max-width: 276px;
                font-weight: 500;
                font-size: 12px;
                color: #D3D3D3;
                line-height: 18px;
            }
        }
    }

    .c {
        font-weight: 500;
        font-size: 12px;
        color: #EAEAEA;
        line-height: 24px;
        text-align: center;
    }
}
</style>